export default __webpack_public_path__ + "images/0x800822d361335b4d5f352dac293ca4128b5b605f.png";